// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/login_bg.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".logon_wrap[data-v-4d673d77]{position:relative;width:100%;height:100%;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat;background-size:cover;background-position:50%;overflow-y:auto}.c_outer[data-v-4d673d77]{position:absolute;left:50%;top:50%;width:960px;height:680px;margin-top:50px;background-color:#fff;border-radius:20px;transform:translate(-50%,-50%)}.c_inner[data-v-4d673d77]{width:360px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
